import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import qs from 'qs';
import { useCallback } from 'react';
import { query } from '../../gql/queries/get-accounts';

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      id
      business_dba
      legal_name
      primary_contact
      email
      title
      country_code
      calling_code
      phone
      # Promoter Information
      promoter_name
      promoter_email
      promoter_phone
      website
      org_name
      promoter_type
      # Addresses
      track {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      mailing {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      shipping {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      track_ids
      series_ids
      stripe_account_id
      divisions {
        id
        name
      }
    }
  }
`;

export function useCreateAccount() {
  const [createAccountMutation, { loading }] = useMutation(CREATE_ACCOUNT, {
    update: (proxy, { data: { createAccount } }) => {
      try {
        const search = qs.parse(window.location.search, {
          ignoreQueryPrefix: true,
        });

        const data = proxy.readQuery({
          query,
          variables: { input: search },
        });

        if (data?.getAccounts) {
          const sort = (newAccount) => {
            const newResults = data.getAccounts.results.concat(newAccount);

            newResults.sort(function (a, b) {
              if (a.business_dba.toLowerCase() < b.business_dba.toLowerCase()) {
                return -1;
              }
              if (a.business_dba > b.business_dba) {
                return 1;
              }
              return 0;
            });

            return newResults;
          };

          proxy.writeQuery({
            query,
            variables: { input: search },
            data: {
              ...data,
              getAccounts: {
                ...data.getAccounts,
                count: data.getAccounts.count + 1,
                results: sort(createAccount),
              },
            },
          });
        }
      } catch (e) {
        // Cache may not have the query, which is fine
      }
    },
  });

  const createAccount = useCallback(
    async (input) => {
      try {
        const result = await createAccountMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.createAccount };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [createAccountMutation]
  );

  return { createAccount, loading };
}
